export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FeaturedPostListing.vue?vue&type=template&id=22c66a6a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedPostListing.vue?vue&type=template&id=22c66a6a&scoped=true
// module id = 214
// module chunks = 0